export const validateRequirements = (
  password: string | null,
  requirements: any[],
  setRequirements: (requirements: any[]) => void
): boolean => {
  let isValid = true;
  const newRequirements = requirements.map(p => {
    if (p.validatior(password || '')) {
      return {
        ...p,
        isValid: true,
      };
    }
    isValid = false;
    return {
      ...p,
      isValid: false,
    };
  });

  setRequirements(newRequirements);
  return isValid;
};
